<style scoped>
.ipt-sty {
  width: 70% !important;
}
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
/deep/ .el-table__expand-icon {
    display: none; 
}
</style>
<template>
  <div class="content"   v-loading.fullscreen.lock="fullscreenLoading">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6"
          ><div class="search-area-div">企业名称</div>
             <el-select size="mini" v-model="page.guid" filterable placeholder="请选择" clearable class="ipt-sty">
                <el-option
                  v-for="item in tableData1"
                  :key="item.sendTenantGuid"
                  :label="item.sendTenantName"
                  :value="item.sendTenantGuid">
                </el-option>
              </el-select>
           </el-col>
        <el-col :span="6" class="search-btn-box">
          <el-button size="mini" type="info" @click="getData(true)">搜索</el-button>
          <el-button size="mini" type="danger" @click="empty">清空</el-button>
        </el-col>
      </el-row>
    </div>
    <!-- <div class="button-area">
      <el-button icon="el-icon-plus" size="mini" type="info" @click="add(1, '')">添加岗位</el-button>
      <el-button size="mini" type="danger" @click="getDeleteData(1, '')">批量删除</el-button> 
    </div> -->
    <div class="back-color-fff content-main-box"  :style="'height:' + contentMainHeight + 'px;'">
      <el-table ref="table" :data="tableData" stripe border :height="tableHeight" style="width: 100%;" v-loading="loading">
        <!-- <el-table-column type="selection" width="60" header-align="center" align="center"></el-table-column> -->
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{(page.pageIndex - 1) * page.pageSize + scope.$index + 1}}
          </template>
        </el-table-column>
        <el-table-column prop="sendTenantName" label="药企方名称" width="210" show-overflow-tooltip header-align="left" align="left"></el-table-column>
        <el-table-column prop="serviceNumber" label="服务商数量" width="150" header-align="center" align="center">
          <template slot-scope="scope">
            <a class="txt-color text-line" @click="toogleExpand(scope.row,scope.$index)">{{scope.row.serviceNumber}}</a> 
          </template>
        </el-table-column>
        <el-table-column type="expand"  width="1">
          <template slot-scope="props">
            <el-form label-position="left" inline class="demo-table-expand">
              <el-table
                :data="props.row.areaRangeList"
                stripe border
                max-height="250">
                <el-table-column label="序号" width="60" header-align="center" align="center">
                  <template slot-scope="scope">
                    <!-- {{ scope.$index + 1 }} -->
                    {{(page.pageIndex - 1) * page.pageSize + scope.$index + 1}}
                  </template>
                </el-table-column>
                <el-table-column
                  width="300"
                  prop="serviceTenantName" show-overflow-tooltip
                  label="运营方名称">
                </el-table-column>
                <el-table-column
                  label="业务地域范围">
                  <template slot-scope="scope">
                    <div class="fl mr10" style="text-align: justify;" v-for="area in scope.row.areaRangeList" v-if="scope.row.areaRangeList != null && scope.row.areaRangeList.length > 0">
                      {{area.province | province}}{{area.city | city}}
                    </div>
                    <div v-if="scope.row.areaRangeList == null">暂无数据!</div>
                  </template>
                </el-table-column>
              </el-table>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="药企开户时间" width="130" sortable header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.createTime | getDate }}</template>
         </el-table-column> 
        <el-table-column prop="" label="组织架构信息" header-align="center" align="center"> 
          <template slot-scope="scope"><a class="txt-color text-line" @click="toPath(scope.row,'组织架构信息')">查看</a></template>
        </el-table-column> 
        <el-table-column prop="" label="岗位信息" header-align="center" align="center">
          <template slot-scope="scope"><a class="txt-color text-line" @click="toPath1(scope.row,'岗位信息')">查看</a></template>
        </el-table-column>
        <el-table-column prop="" label="角色信息" header-align="center" align="center">
          <template slot-scope="scope"><a class="txt-color text-line" @click="toPath2(scope.row,'角色信息')">查看</a></template>
        </el-table-column>
        <el-table-column prop="" label="人员信息" header-align="center" align="center">
          <template slot-scope="scope"><a class="txt-color text-line" @click="toPath3(scope.row,'人员信息')">查看</a></template>
        </el-table-column>
         <el-table-column prop="" label="销售区域" header-align="center" align="center">
          <template slot-scope="scope"><a class="txt-color text-line" @click="toPath4(scope.row),'销售区域'">查看</a></template>
        </el-table-column>
         <el-table-column prop="" label="核算单元" header-align="center" align="center">
          <template slot-scope="scope"><a class="txt-color text-line" @click="toPath5(scope.row,'核算单元')">查看</a></template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10,20,50,100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
    <el-dialog :title="textTitle" :visible.sync="dialogFormVisible" width="550px">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        :label-position="right"
        class="demo-ruleForm"
      >
        <el-form-item label="岗位:" prop="positionName">
          <el-input v-model="ruleForm.positionName" autocomplete="off" class="w100f"></el-input>
        </el-form-item>
        <!-- <el-form-item label="显示顺序:" prop="orderNum">
          <el-input v-model="ruleForm.orderNum" autocomplete="off" class="w100f"></el-input>
        </el-form-item> -->
        <el-form-item label="状态:" class="t-left">
          <el-radio v-model="ruleForm.bizState" label="Y">有效</el-radio>
          <el-radio v-model="ruleForm.bizState" label="S">停用</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button plain size="mini" @click="dialogFormVisible = false">取消</el-button>
        <el-button size="mini" type="info" v-if="textTitle == '添加岗位'" @click="submitForm('ruleForm')"
          >确定</el-button
        >
        <el-button size="mini" type="info" v-else @click="upDateForm('ruleForm')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableHeight: window.innerHeight - 220,
      input: '',
      textTitle: '',
      right: '',
      dialogVisible: false,
      dialogFormVisible: false,
      formLabelWidth: '120px',
      ruleForm: {
        guid: '',
        positionName: '',
        orderNum: '', 
        bizState: 'Y',
      },
      page: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        guid:'',
        bizState: 'Y',
        enterpriseCates: this.$getValueListByKey('上游客户分类')
      },
      loading:false,
      tableData: [],
      tableData1: [],
      rules: {
        positionName: [
          { required: true, message: '请输入岗位', trigger: 'blur' },
          { min: 1, max: 30, message: '长度在 1 到 30 个字符', trigger: 'blur' },
        ],
        orderNum: [
          { required: true, message: '请输入顺序', trigger: 'blur' },
          { min: 1, max: 60, message: '长度在 1 到 30 个字符', trigger: 'blur' },
        ], 
      },
      multipleSelection: [],
      fullscreenLoading:false
    };
  },
  created() {
    // 列表
    this.getData(false);
    this.getSelectData();
  },
  methods: {
    toogleExpand(row,index) {
      let table = this.$refs.table;
      let self = this;
      self.tableData[index].areaRangeList = [];
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`,{'tenantGuid':row.sendTenantGuid,'isService':false}).then((res) => {
         self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData[index].areaRangeList = res.data.data;
          self.tableData.map((item) => {
            if (row.sendTenantGuid != item.sendTenantGuid) {
              table.toggleRowExpansion(item, false)
            }
          })
          table.toggleRowExpansion(row)
        } else {
          self.$message.error(res.data.msg);
        }
      });
   
   
   
    },
    toPath(row,title){ 
      localStorage.selectPath = '/drugCompaniesHome'
      let routeUrl = this.$router.resolve({ path: '/drugOrganizationalStructure', query: { tenantGuid: row.sendTenantGuid, tenantName: row.sendTenantName,productGuid:this.$route.query.productGuid, pageTitle:title } });
      window.open(routeUrl.href, '_blank');  
    },
    toPath1(row,title){  
      localStorage.selectPath = '/drugCompaniesHome'
      let routeUrl = this.$router.resolve({ path: '/drugPostManagement', query: { tenantGuid: row.sendTenantGuid, tenantName: row.sendTenantName,productGuid:this.$route.query.productGuid, pageTitle:title } });
      window.open(routeUrl.href, '_blank');  
    },
    toPath2(row,title){ 
      localStorage.selectPath = '/drugCompaniesHome'
      let routeUrl = this.$router.resolve({ path: '/drugRoleManagement', query: { tenantGuid: row.sendTenantGuid, tenantName: row.sendTenantName,productGuid:this.$route.query.productGuid, pageTitle:title } });
      window.open(routeUrl.href, '_blank');  
    },
    toPath3(row,title){ 
      localStorage.selectPath = '/drugCompaniesHome'
      let routeUrl = this.$router.resolve({ path: '/drugManagementPersonnel', query: { tenantGuid: row.sendTenantGuid, tenantName: row.sendTenantName,productGuid:this.$route.query.productGuid, pageTitle:title } });
      window.open(routeUrl.href, '_blank'); 
    },
    toPath4(row,title){  
      localStorage.selectPath = '/drugCompaniesHome'
      let routeUrl = this.$router.resolve({ path: '/drugSalesArea', query: { tenantGuid: row.sendTenantGuid, tenantName: row.sendTenantName,productGuid:this.$route.query.productGuid, pageTitle:title } });
      window.open(routeUrl.href, '_blank');
    },
    toPath5(row,title){  
      localStorage.selectPath = '/drugCompaniesHome'
      let routeUrl = this.$router.resolve({ path: '/drugBusinessUnit', query: { tenantGuid: row.sendTenantGuid, tenantName: row.sendTenantName,productGuid:this.$route.query.productGuid, pageTitle:title } });
      window.open(routeUrl.href, '_blank');
    },
    empty() {
      let self = this;
      self.page = {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        bizState: 'Y',
        enterpriseCates: this.$getValueListByKey('上游客户分类')
      };
      self.getData(true);
    },
    getData(flg) {
      let self = this;
      self.loading = true;
      if (flg) {
        self.page.pageIndex = 1;
      }
      // self.page.tenantGuid = self.$store.getters.getTenantGuid;
      self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation`, self.page).then(res => {
        self.loading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records; 
          if(self.tableData){
            // self.tableData.forEach(function(item,index) {
            //   self.getTenantOperationRelList(item.sendTenantGuid,index);
            // });
            self.page.totalPage = res.data.data.totalPages;
            self.page.totalRows = res.data.data.totalRows;
          }
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getSelectData() {
      let self = this; 
      // self.page.tenantGuid = self.$store.getters.getTenantGuid;
      self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation`,{'pageIndex':1,'pageSize':-1,'bizState':'Y','enterpriseCates':this.$getValueListByKey('上游客户分类')}).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData1 = res.data.data.records;   
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getTenantOperationRelList(guid,index){
      let self = this; 
      self.tableData[index].areaRangeList = [];
      self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`,{'tenantGuid':guid,'isService':false}).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData[index].areaRangeList = res.data.data;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    handleSelectionChange(val) {
      let self = this;
      self.multipleSelection = [];
      val.forEach(function(item) {
        //item 就是当日按循环到的对象
        self.multipleSelection.push(item.guid);
      });
    },

    getDeleteData(flg, guid) {
      let self = this;
      if (flg == 1) {
        if (self.multipleSelection.length == 0) {
          self.$message.error('请勾选数据！');
          return;
        }
      } else {
        self.multipleSelection = [];
        self.multipleSelection.push(guid);
      }
      this.$confirm('当前岗位有用户使用，是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          self.api
            .postJson(`/${serverConfig.msPersonnelService}/position/data/delete`, self.multipleSelection)
            .then(res => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.multipleSelection = [];
                self.$message.success('删除岗位成功');
                self.getData(true);
              } else {
                self.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    add(flg, row) {
      let self = this;
      if (flg == 1) {
        self.textTitle = '添加岗位';
        self.ruleForm.positionName = '';
        self.ruleForm.orderNum = '';
        self.ruleForm.bizState = 'Y';
      } else {
        self.textTitle = '编辑岗位';
        self.ruleForm.guid = row.guid; 
        self.ruleForm.positionName = row.positionName;
        self.ruleForm.orderNum = row.orderNum;
        self.ruleForm.bizState = row.bizState;
      }
      this.dialogFormVisible = true;
    },
    submitForm(formName) {
      let self = this;
      self.$refs[formName].validate(valid => {
        if (valid) {
          let promise = {
            tenantGuid: self.page.tenantGuid,
            positionName: self.ruleForm.positionName,
            orderNum: self.ruleForm.orderNum,
            bizState: self.ruleForm.bizState,
          };
          self.api.postJson(`/${serverConfig.msPersonnelService}/position/data/add`, promise).then(res => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.dialogFormVisible = false;
              self.$message.success('添加岗位成功');
              self.getData(true);
            } else {
              self.$message.error(res.data.msg);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    upDateForm(formName) {
      let self = this;
      self.$refs[formName].validate(valid => {
        if (valid) {
          let promise = {
            guid: self.ruleForm.guid,
            tenantGuid: self.page.tenantGuid,
            positionName: self.ruleForm.positionName,
            orderNum: self.ruleForm.orderNum,
            bizState: self.ruleForm.bizState,
          };
          self.api.put(`/${serverConfig.msPersonnelService}/position/data/update`, promise).then(res => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.dialogFormVisible = false;
              self.$message.success('编辑岗位成功');
              self.getData(true);
            } else {
              self.$message.error(res.data.msg);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
  },
};
</script>
